module.exports = __webpack_public_path__ + "images/2.1792157180594.jpg";